import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/landing';
export function FloatingCta({
  visible
}: {
  visible: boolean;
}) {
  return <AnimatePresence data-id="element-32" data-mp="3twxlciymq17h">
      {visible && <motion.div initial={{
      y: 110,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 110,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-950/95 px-3 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] backdrop-blur" data-id="element-33" data-mp="3oxaxzgp374ky">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex max-w-md items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-cta-500 px-4 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_4px_0_0_#0f5f2c] hover:bg-cta-600 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-400/60" data-id="element-34" data-mp="gnj25yrrf7kw">
            Yes! Get it for only $27
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-35" data-mp="2f3snikpxvufi" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}